import { Attributes, Validation, ValueObject } from '@singularsystems/neo-core';
import { ReportType } from '../ReportType';

export default class LetterAuthorisationCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public letterAuthorisationBatchId: number = 0;

    public reportType: ReportType | null = null;

    public incomplete: boolean = false;

    @Attributes.Nullable()
    public requireSigningBy: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Letter Authorisation Criteria";
    }
}